export default __webpack_public_path__ + "static/media/lynnFit.1c99acec.png";